<template>
  <div class="wrap">
    <header class="header">
      <span class="iconfont icon-back-left" @click="goBack"></span>
      <h2>{{coinName}}/USDT</h2>
    </header>
    <div class="teamInfo">
      <p class="top">{{ curPrice }}</p>
      <div class="bottom">
        <p>
          <span class="red">{{lang.opentoday}}</span>
          <span>{{ coinInfo.priceOpen }}</span>
        </p>
        <p>
          <span class="green">{{lang.highest}}</span>
          <span>{{ coinInfo.priceHigh }}</span>
        </p>
        <p>
          <span class="green">{{lang.lowest}}</span>
          <span>{{ coinInfo.priceLow }}</span>
        </p>
      </div>
    </div>
    <div class="navbox">

      <div class="right" style="display: flex">
        <p :class="{'active':mtype==item}" v-for="(item,index) in marr" :key="index" @click="mtype=item">{{item}}</p>
      </div>
    </div>
    <div class="main">
      <p class="timebox" v-if="karr.length">
        <span>{{tarr[tarr.length-1]}}</span>
        <span>{{Number(karr[karr.length-1][0]).toFixed(4)}}</span>
        <span>{{Number(karr[karr.length-1][1]).toFixed(4)}}</span>
        <span>{{Number(karr[karr.length-1][2]).toFixed(4)}}</span>
        <span>{{Number(karr[karr.length-1][3]).toFixed(4)}}</span>
      </p>
      <div id="echart01" :key="0" v-show="ltype==0"></div>
      <div id="echart02" :key="1" v-show="ltype==1"></div>
      <p class="diffbox" v-if="narr.length"><span>{{lang.turnover}}:{{coinInfo.volume}}</span></p>
      <div id="echart03"></div>
    </div>
    <div class="bottombox">
      <div class="left" @click="buy(0)">{{lang.buyup}}</div>
      <div class="right" @click="buy(1)">{{lang.buyshort}}</div>
    </div>
    <van-action-sheet v-model="sheetShow"  >
      <div class="contentq" v-if="types == 1">
        <div class="exit">
          <div class="tagse">
            <div :class="['tag',types == 1 ? 'active':'']" @click="types=1">{{ lang.qiquan }}</div>
            <div :class="['tag',types == 2 ? 'active':'']" @click="types=2">{{lang.heyue}}</div>
          </div>
          <van-button icon="cross" color="#1a1a1a" size="small" @click="sheetShow=false"/>
        </div>
        <div class="title">
          <div class="left">{{coinName}}/USDT</div>
          <div class="right">{{ curPrice }}</div>
        </div>
        <div class="items" >
          <div :class="['item', item.id == repayId ?  'active':'']" v-for="item in repayList" @click="selectRepay(item)">
            <div class="top">{{ item.tradingHours }}S</div>
            <div class="bottom">{{ lang.hbl }} {{ item.income }}%</div>
          </div>
        </div>
        <div class="input-list">
          <div class="lable">{{ lang.amount }}</div>
          <div class="input-content">
            <input class="readonly-input" type="text" v-model="amt">
            <div class="input-button input-buttons" @click="maxAmt">{{ lang.max }}</div>
          </div>
        </div>
        <div class="amtInfo">
          <div class="amtItem">
            <span class="top">{{ lang.coin }}</span>
            <span class="bottom">{{ coinInfo.blc }}</span>
          </div>
          <div class="amtItem">
            <span class="top">{{ lang.yjsy }}</span>
            <span class="bottom">+${{expect}}</span>
          </div>
          <div class="amtItem">
            <span class="top">{{lang.fee}}</span>
            <span class="bottom">${{fee.toFixed(4)}}</span>
          </div>
        </div>
        <div class="confirm-button" @click="submit">{{ lang.confirm }}</div>
      </div>
      <div class="contentq" v-else>
        <div class="exit">
          <div class="tagse">
            <div :class="['tag',types == 1 ? 'active':'']" @click="types=1">{{ lang.qiquan }}</div>
            <div :class="['tag',types == 2 ? 'active':'']" @click="types=2">{{lang.heyue}}</div>
          </div>
          <van-button icon="cross" color="#1a1a1a" size="small" @click="sheetShow=false"/>
        </div>
        <div class="pross-title">{{lang.gangg}}:{{hyLeverage}}X </div>
        <div class="leverage-progress" @click="handleClick" @touchstart="startDrag" @touchmove="drag" @touchend="endDrag">
          <!-- 背景进度条 -->
          <div class="progress" :style="{ width: progressWidth + '%' }"></div>
          <!-- 各个端点的圆形标记，根据当前进度动态设置 class -->
          <div class="progress-circular" :class="{ 'progress-active': progressWidth >= 1 }" style="left: 0%;"></div>
          <div class="progress-circular" :class="{ 'progress-active': progressWidth >= 25 }" style="left: 25%;"></div>
          <div class="progress-circular" :class="{ 'progress-active': progressWidth >= 50 }" style="left: 50%;"></div>
          <div class="progress-circular" :class="{ 'progress-active': progressWidth >= 75 }" style="left: 75%;"></div>
          <div class="progress-circular" :class="{ 'progress-active': progressWidth >= 98 }" style="left: 98%;"></div>
          <!-- 可移动的进度点 -->
          <div class="progress-circular progress-ring-active" :style="{ left: progressWidth + '%' }"></div>
        </div>
        <div class="progress-identification">
          <div class="identification-1x">1X</div>
          <div class="identification-25x">50X</div>
          <div class="identification-50x">100X</div>
          <div class="identification-75x">150X</div>
          <div class="identification-100x">200X</div>
        </div>
        <div class="entrust">
          <span>{{ lang.xianjia }}</span>
          <el-switch v-model="checked" />
        </div>
        <div class="input-list">
          <div class="lable">{{ lang.buyj }}</div>
          <div class="input-content">
            <input class="readonly-input" type="text" v-model="hyCurPrice" v-if="checked">
            <input class="readonly-input" type="text" :disabled="!checked" v-model="curPrice" v-else>
            <div class="option" >{{coinName}}/USDT</div>
          </div>
        </div>
        <div class="input-list">
          <div class="lable">{{ lang.buysl }}</div>
          <div class="input-content">
            <input class="readonly-input" type="number" v-model="hyNum">
            <div class="input-button input-buttons" style="margin-right: 10px" @click="reduceNum">-10</div>
            <div class="input-button input-buttons" @click="addNum">+10</div>
          </div>
          <div class="margins">
            <div>{{ lang.sxbzj }}:${{ hyBzj }}</div>
            <div>{{ lang.fy }}:${{ hyFee }}</div>
          </div>
        </div>
        <div class="entrust">
          <span>{{ lang.xiane }}</span>
          <el-switch v-model="checked2" />
        </div>
        <div class="input-lists" v-if="checked2">
          <div class="input-list" style="flex: 0 0 47%;">
            <div class="lable">{{lang.zhiying}}</div>
            <div class="input-content">
              <input class="readonly-input" type="text" v-model="hyCurPriceAdd">
            </div>
          </div>
          <div class="input-list" style="flex: 0 0 47%;">
            <div class="lable">{{lang.zhisun}}</div>
            <div class="input-content">
              <input class="readonly-input" type="text" v-model="hyCurPricereduce">
            </div>
          </div>
        </div>

        <div class="confirm-button" @click="hySubmit">{{ lang.confirm }}</div>
      </div>
    </van-action-sheet>
    <van-action-sheet v-model="sheetShow2" @closed="goBack">
      <div class="contentq">
        <div class="exit">
          <div class="tagse">
            <div :class="['tag',types == 1 ? 'active':'']" @click="types=1">{{ lang.qiquan }}</div>
            <div :class="['tag',types == 2 ? 'active':'']" @click="types=2">{{lang.heyue}}</div>
          </div>
          <van-button icon="cross" color="#1a1a1a" size="small" @click="sheetShow2=false"/>
        </div>
        <div class="title">
          <div class="left">{{coinName}}/USDT</div>
          <div class="right">{{ curPrice }}</div>
        </div>
        <div class="items" style="    justify-content: center;" >
          <div class="item active" >
            <div class="top">{{ recordInfo.seconds  }}S</div>
            <div class="bottom">{{ lang.hbl }} {{ income }}%</div>
          </div>
        </div>
        <div class="content1-infos">
          <div class="infos1">
            <div class="info1">
              <div class="info1-lable">{{ lang.amount }}</div>
              <div>${{amt}}</div>
            </div>
            <div class="info1">
              <div class="info1-lable">{{ lang.yjsy }}</div>
              <div>+${{expect}}</div>
            </div>
          </div>
          <div class="infos1 ">
            <div class="info1">
              <div class="info1-lable">{{ lang.kpprice }}</div>
              <div>{{ buyPrice }}</div>
            </div>
            <div class="info1">
              <div class="info1-lable">{{ lang.dqjg }}</div>
              <div>{{ curPrice }}</div>
            </div>
          </div>
          <div class="infos2">
            <div class="info1">
              <div class="info1-lable">{{ lang.fy }}</div>
              <div> ${{ fee.toFixed(4) }}</div>
            </div>
            <div class="info1">
              <div class="info1-lable">{{lang.direction}}</div>
              <div v-if="updown == 0" style="color: #c2e22a">{{ lang.buyup }}</div>
              <div v-else style="color: #ce7735">{{ lang.buyshort }}</div>
            </div>
          </div>
        </div>
        <div class="confirm-button" @click="goBack">{{ lang.confirm }}</div>
      </div>
    </van-action-sheet>
    <mt-popup v-model="popupVisible" position="bottom" class="orderbox">
      <div class="tit">
        <span></span>
        <h2>{{lang.confirmOrder}}</h2>
        <span class="iconfont icon-guanbi" @click="popupVisible=false"></span>
      </div>
      <p class="itemtitle">{{lang.buyAmount}} (min: {{currSymbol}}{{quickBet}})</p>
      <div class="item item02">
        <!-- <p v-for="(item,index) in quickBet" :key="index" @click="amount=item" :class="{'active':amount==item}">
          <span>{{currSymbol}}{{item}}</span>
        </p> -->
        <p><input type="text" v-model.number="amount" :placeholder="amount" :readonly="amtRO"></p>
      </div>
      <div class="item item01">
        <p v-for="(item,index) in expiration" :key="index"  @click="selectAmt(item,index)">
          <span>{{item}}</span>
        </p>
      </div>
      <p class="itemtitle" style="justify-content: space-between;">
        <span>{{lang.coin}}：{{userInfo.blc}}</span>
        <span>{{lang.lockTime}}：{{lockFor}}</span>
      </p>
      <div class="btn" @click="submit">{{lang.confirm}}</div>
    </mt-popup>
    <mt-popup v-model="popupVisible02" position="bottom" class="orderInfo">
      <div class="header">
        <span class="iconfont icon-back-left" @click="popupVisible02=false"></span>
        <h2>{{coinName}}</h2>
        <span></span>
      </div>
      <div class="timebox" v-if="secs>=0">
        <span>{{ countdown }}</span>
        <span>{{lang.currentPrice}}</span>
        <span>{{ jsPrice }}</span>
      </div>
      <div v-else>
        <span>{{amount}}</span>
        <span>{{lang.dqjscom}}</span>
      </div>
      <div class="content">
        <p>
          <span>{{lang.direction}}</span>
          <span :class="[direct?'green':'red']">{{direct?lang.buyup:lang.buyshort}}</span>
        </p>
        <p>
          <span>{{lang.amount}}</span>
          <span>{{currSymbol}}{{amount}}</span>
        </p>
        <p>
          <span>{{lang.strikePrice}}</span>
          <span>{{betPrice}}</span>
        </p>
        <p>
          <span>{{lang.ycsy}}</span>
          <span class="green">{{ amount * (1 + profit[secs] / 100) }}</span>
        </p>
        
      </div>
      <div class="btn" @click="popupVisible02=false">{{lang.keepBuy}}</div>
    </mt-popup>
  </div>
</template>
<script>
import { CONF } from '@/assets/js/config'
  import {
    mapState
  } from 'vuex';
  import axios from 'axios'
  import * as echarts from 'echarts';
  export default {
    data() {
      return {
        //合约
        hyNum:0,
        hyFee:0,
        hyBzj:0,
        hyCurPrice:0,
        hyCurPriceAdd:0,
        hyCurPricereduce:0,
        hyLeverage:200,


        amt: 1,
        income: "",
        types: 1,
        expect: 0,
        fee: 0,
        repayList: [],
        repayId: 0,
        updown: 0,
        buyPrice: 0,
        user: {},
        recordInfo: {
          seconds:0,
        },

        ltype: 0,
        mtype: '1M',
        amount: 0,
        secs: 0,
        lockFor: "1H",
        larr: ['kline', 'trend'],
        marr: ['1M', '5M', '15M', '30M', '1H', '1D'],
        checked: false,
        checked2: false,
        showInp: false,
        sheetShow: false,
        sheetShow2: false,
        popupVisible: false,
        popupVisible02:false,
        coinName: '',
        interval:1,
        direct: '',
        expiration: [],
        // moneyArr: [],
        myChart01: null,
        myChart02: null,
        myChart03: null,
        karr:[],//k线图
        parr:[],//价格曲线
        narr:[],//交易量曲线
        tarr:[],//时间轴
        timer:null,
        curPrice:0,
        coinInfo:{},
        quickBet:0,
        profit:[],
        countdown:0,
        betPrice:0,
        jsPrice:0,
        oid:0,
        bonus:0,
        betRltTimer:0,
        currSymbol: CONF.CURR_SYMBOL,
        amtRO: false,
        dragging: false,
        timers: "",
        progressWidth: 98, // 当前进度，以百分比表示
      }
    },
    created() {
      this.coinName = this.$route.query.coinName;
      this.getData();
      this.getRepay();
      clearInterval(this.timer)
      clearInterval(this.timers)
      this.timer = setInterval(()=>{
          this.getdata02(this.coinName,this.mtype.toLowerCase());
      },2e3)
    },
    beforeDestroy(){
      clearInterval(this.timer);
      clearInterval(this.timers);
      clearInterval(this.betRltTimer);
      this.betRltTimer = null;
      this.timer = null;
      this.timers = null;
    },
    watch: {
      amt(newValue, oldValue) {
        this.checkAmt(newValue)
      },
      repayId(newValue, oldValue) {
        this.checkAmt(newValue)
      },
      checked(newValue, oldValue) {
        if (newValue){
          this.hyCurPrice = this.curPrice
        }
      },
      checked2(newValue, oldValue) {
        if (newValue){
          var curPrice = this.curPrice
          if (this.updown == 1){
            this.hyCurPricereduce = (curPrice - 10).toFixed(1)
            this.hyCurPriceAdd = ( (curPrice * 10 + 10 * 10) / 10).toFixed(1);
          }else {
            this.hyCurPricereduce = ( (curPrice * 10 + 10 * 10) / 10).toFixed(1);
            this.hyCurPriceAdd = (curPrice - 10).toFixed(1)
          }

        }
      },
      hyNum(newValue, oldValue) {
        this.hyBzj = (this.coinInfo.handMoney / this.hyLeverage * Math.floor(newValue)).toFixed(2)
        this.hyFee = (this.hyBzj * this.coinInfo.tk_fee).toFixed(2)
      },
      progressWidth(newValue, oldValue) {
        if (newValue == 0){
          newValue = 1
        }
        if (newValue >100){
          this.hyLeverage = Math.floor((newValue+2) * 2)
        }else {
          this.hyLeverage = Math.floor(newValue)
        }

        this.hyBzj = (this.coinInfo.handMoney / this.hyLeverage * Math.floor(this.hyNum)).toFixed(2)
        this.hyFee = (this.hyBzj * this.coinInfo.tk_fee).toFixed(2)
      },
    },
    computed: {
      ...mapState(['lang','userInfo']),
    },
    methods: {
      selectAmt(item,index){
        this.secs = index
        if (item == "ALL"){
          this.amount = this.userInfo.blc
        }else{
          this.amount = item
        }
      },
      selectRepay(item){
        this.repayId = item.id
        this.income = item.income
      },
      handleClick(event) {
        // 获取点击的相对位置
        const progressBar = event.currentTarget;
        const clickX = event.clientX - progressBar.getBoundingClientRect().left;
        const progressBarWidth = progressBar.offsetWidth;

        // 计算点击位置对应的进度百分比
        const newProgress = (clickX / progressBarWidth) * 100;

        // 更新进度值并将其限制在 0 到 100 之间
        this.progressWidth = Math.min(Math.max(newProgress, 0), 98);
      },
      checkAmt(newValue){
        for (var i in this.repayList){
          if (this.repayList[i].id == this.repayId){
            this.expect = this.amt * this.repayList[i].income / 100
            break
          }
        }
        var f = parseFloat(this.coinInfo.tk_fee)
        this.fee = newValue * f  / 100
      },
      maxAmt(){
        this.amt = this.coinInfo.blc
      },
      goBack() {
        this.$router.go(-1)
      },
      toDou(n) {
        return n < 10 ? "0" + n : n
      },
      format(shijianchuo){
        //shijianchuo是整数，否则要parseInt转换
        var time = new Date(parseInt(shijianchuo));
        var h = time.getHours();
        var m = time.getMinutes();
        return this.toDou(h)+':'+this.toDou(m);
      },
      choseLtype(index) {
        this.ltype = index;
      },
      getCanvas01() {
        if (this.myChart01) this.myChart01.dispose();
        var chartDom = document.getElementById("echart01");
        this.myChart01 = echarts.init(chartDom);
        var option;

        const upColor = '#ec0000';
        const upBorderColor = '#8A0000';
        const downColor = '#00da3c';
        const downBorderColor = '#008F28';
        // Each item: open，close，lowest，highest
        const data0 = splitData(this.karr.slice(-50));

        function splitData(rawData) {
          const categoryData = [];
          const values = [];
          for (var i = 0; i < rawData.length; i++) {
            categoryData.push(rawData[i].splice(0, 1)[0]);
            values.push(rawData[i]);
          }
          return {
            categoryData: categoryData,
            values: values
          };
        }

        function calculateMA(dayCount) {
          var result = [];
          for (var i = 0, len = data0.values.length; i < len; i++) {
            if (i < dayCount) {
              result.push('-');
              continue;
            }
            var sum = 0;
            for (var j = 0; j < dayCount; j++) {
              sum += +data0.values[i - j][1];
            }
            result.push(sum / dayCount);
          }
          return result;
        }
        option = {
          animation: false,
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          legend: {
            data: [this.lang['rk'], this.lang['kpprice'],this.lang['maxprice'], this.lang['spprice'], this.lang['minprice']],
            itemWidth: 8,
            itemHeight: 6,
            textStyle: {
              color: "rgba(255,255,255,.5)",
              fontSize:10
            }
          },
          grid: {
            left: "5%",
            right: "15%",
            bottom: "10%",
            top: "10%",
          },
          xAxis: {
            type: 'category',
            data: data0.categoryData,
            scale: true,
            boundaryGap: false,
            axisLine: {
              onZero: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            min: 'dataMin',
            max: 'dataMax'
          },
          yAxis: {
            position: 'right',
            scale: true,
            axisLabel: {
              textStyle: {
                color: "rgba(255,255,255,.3)",
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.3)",
              },
            }, //去除网格
          },
          dataZoom: [{
            type: 'inside',
            start: 50,
            end: 100
          }],
          series: [{
              name: this.lang['rk'],
              type: 'candlestick',
              data: data0.values,
              itemStyle: {
                color: upColor,
                color0: downColor,
                borderColor: upBorderColor,
                borderColor0: downBorderColor
              },
            },
            {
              name: this.lang['kpprice'],
              type: 'line',
              data: calculateMA(5),
              smooth: true,
              symbol: 'none',
              lineStyle: {
                opacity: 0.5
              }
            },
            {
              name: this.lang['maxprice'],
              type: 'line',
              data: calculateMA(10),
              smooth: true,
              symbol: 'none',
              lineStyle: {
                opacity: 0.5
              }
            },
            {
              name: this.lang['spprice'],
              type: 'line',
              data: calculateMA(20),
              smooth: true,
              symbol: 'none',
              lineStyle: {
                opacity: 0.5
              }
            },
            {
              name: this.lang['minprice'],
              type: 'line',
              symbol: 'none',
              data: calculateMA(30),
              smooth: true,
              lineStyle: {
                opacity: 0.5
              }
            }
          ]
        };

        option && this.myChart01.setOption(option);
      },
      getCanvas02() {
        if (this.myChart02) this.myChart02.dispose();
        var chartDom = document.getElementById("echart02");
        this.myChart02 = echarts.init(chartDom);
        var option;
        option = {
          animation: false,
          grid: {
            left: "5%",
            right: "15%",
            bottom: "10%",
            top: "10%",
          },
          tooltip: {
            trigger: "axis",
            position: function (pt) {
              return [pt[0], "10%"];
            },
          },
          xAxis: {
            type: 'category',
            data: this.tarr.slice(-50),
            axisLabel: {
              textStyle: {
                color: "rgba(255,255,255,.3)",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(29, 197, 255, .2)"
              }
            },
            axisTick: {
              show: false
            }
          },
          yAxis: {
            position: 'right',
            type: 'value',
            axisLabel: {
              textStyle: {
                color: "rgba(255,255,255,.3)",
              },
              formatter: function (value) {
                return value.toFixed(4);
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(242, 242, 14)"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.3)",
              },
            }, //去除网格,
            axisTick: {
              show: false
            }
          },
          series: [{
            name: this.lang.shuzhi,
            type: "line",
            smooth: false,
            symbol: "none",
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(242, 242, 14, .8)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(242, 242, 14, 0.1)'
                  }
                ])
              }
            },
            itemStyle: {
              normal: {
                color: 'rgb(242, 242, 14)',
              },
            },
            data: this.parr.slice(-50),
          }]
        };

        option && this.myChart02.setOption(option);
      },
      getCanvas03() {
        if (this.myChart03) this.myChart03.dispose();
        var chartDom = document.getElementById("echart03");
        this.myChart03 = echarts.init(chartDom);
        var option;
        option = {
          animation: false,
            tooltip: {
              trigger: 'axis'
            },
            grid: {
              top: '5%',
              bottom: '10%',
              right: '15%',
              left: '5%'
            },
            xAxis: [{
              type: 'category',
              axisLabel: {
                show: false,
                textStyle: {
                  color: "rgba(255,255,255)",
                },
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "rgba(255,255,255)"
                }
              },
              axisTick: {
                show: false //取消坐标轴刻度线
              },
              data: this.tarr.slice(-50)
            }],
            yAxis: [{
                type: 'value',
                position: 'right',
                name: this.lang.turnover,
                axisLine: {
                  show: false, //是否显示坐标线
                  lineStyle: {
                    color: "rgba(255,255,255)"
                  }
                },
                axisTick: {
                  show: false //取消坐标轴刻度线
                },
                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: "rgba(255,255,255,.3)",
                  },
                },
                splitLine: {
                  show: false
                }, //去除网格
              }
            ],
            series: [{
                name: this.lang.turnover,
                type: 'bar',
                data: this.narr.slice(-50),
                itemStyle: {
                  normal: {
                    color: '#53b987 '
                  }
                }
              }
            ]
          },

          option && this.myChart03.setOption(option);
      },
      getData() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest('get', '/product/coinPage', {
            coinName: this.coinName
          })
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              this.coinInfo = res.data.data
              this.checkAmt(this.amt)

            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
      },
      getRepay() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest('get', '/product/repay', {})
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              this.repayList = res.data.data
              this.repayId = this.repayList[0].id
              this.income = this.repayList[0].income
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
      },
      getdata02(c,m){
        // axios.get('https://api.binance.com/api/v3/klines?symbol='+c+'USDT&interval='+m)
        //axios.get('https://data.binance.com/api/v3/klines?symbol='+c+'USDT&interval='+m)
		axios.get('https://data-api.binance.vision/api/v3/klines?symbol='+c+'USDT&interval='+m)
          .then(res => {
            this.karr = [];
            this.parr = [];
            this.narr = [];
            let kline = res.data;
            for(let i=0; i<kline.length; i++){
              let hm = this.format(kline[i][0]);
              let arr02 = [hm,kline[i][1],kline[i][2],kline[i][4],kline[i][3]];//开盘时间、开盘价、最高价、收盘价、最低价
              this.karr.push(arr02);
              this.parr.push(kline[i][7]);
              this.narr.push(kline[i][8]);
              this.tarr.push(hm);
            }
            this.curPrice = Number(kline[kline.length-1][4]).toFixed(this.coinInfo.priceDecimals);
            this.$nextTick(() => {
              this.getCanvas01();
              this.getCanvas02();
              this.getCanvas03();
            })
          })
      },
      buy(updown){
        this.updown = updown
        this.sheetShow = true
        this.amt = 1
        this.repayId = this.repayList[0].id
        this.income = this.repayList[0].income
      },
      submit() {
        this.$xhrPost( '/product/buy',{
          updown:this.updown,
          amt:this.amt.replace(/\D/g,''),
          repayId:this.repayId,
          coinName:this.coinName,
        }).then(res => {
          this.sheetShow = false
          if (res.err == 0) {
            this.coinInfo.blc = res.data.blc
            this.buyPrice = res.data.price
            this.sheetShow2 = true
            this.getRecord(res.data.ordno)
          }else{
            this.$message({message: res.msg,  type: 'error'});
          }
        })
      },
      getRecord(ordno){
        this.$xhrGet('/product/order',{ "ordno":ordno}).then(res => {
          if (res.data.length == 0 || res.totalNum == 0 ){
            clearInterval(this.timers)
            this.goBack()
          }
          this.recordInfo = res.data[0]
          if(this.recordInfo.seconds != 0 ){
            clearInterval(this.timers)
            this.timers = setInterval(()=>{
              this.getRecord(ordno);
            },1e3)
          }
        })
      },

      startDrag(event) {
        this.dragging = true;
        this.updateProgress(event.touches[0]); // 触摸事件
      },
      drag(event) {
        if (this.dragging) {
          this.updateProgress(event.touches[0]); // 触摸事件
        }
      },
      endDrag() {
        this.dragging = false;
      },
      updateProgress(touch) {
        // 获取触摸点的相对位置
        const progressBar = this.$el;
        const touchX = touch.clientX - progressBar.getBoundingClientRect().left;
        const progressBarWidth = progressBar.offsetWidth;

        // 计算触摸点位置对应的进度百分比
        const newProgress = (touchX / progressBarWidth) * 100;

        // 更新进度值并将其限制在 0 到 100 之间
        this.progressWidth = Math.min(Math.max(newProgress, 0), 98);
      },
      addNum(){
        this.hyNum += 10
      },
      reduceNum(){
        if (this.hyNum <10){
          this.hyNum = 0
        }else {
          this.hyNum -= 10
        }
      },
      hySubmit(){
        if(this.hyNum <=0){
          this.$message({message:  "購入数量を入力してください",  type: 'error'});
          return
        }
        this.$xhrPost( '/product/buyHY',{
          updown:this.updown,
          hyNum:this.hyNum,
          checked:this.checked ? 1:0,
          checked2:this.checked2 ? 1:0,
          hyCurPricereduce:this.hyCurPricereduce,
          hyCurPriceAdd:this.hyCurPriceAdd,
          hyCurPrice:this.hyCurPrice,
          progressWidth:this.hyLeverage,
          coinName:this.coinName,
        }).then(res => {
          this.sheetShow = false
          if (res.err == 0) {
            this.$router.push("OptionOrder")
          }else{
            this.$message({message: res.msg,  type: 'error'});
          }
        })
      }
    }
  }
</script>
<style scoped >
.contentq{
  padding: 0.53333rem;
  background: #2a2a2a;
  color: #fff;
  max-height: 70vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.contentq .exit{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.contentq .exit .tagse{
  display: flex;
}
.contentq .exit .tagse .tag{
  opacity: 0.4;
  padding: 7px 22px;
  border-radius: 20px;
  margin-right: 10px;
}
.contentq .exit .tagse .active{
  background: #000;
  opacity: 1;
}
.contentq .title{
  position: relative;
  display: flex;
  padding: 15px;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
}
.contentq .title:before {
  content: "";
  display: inline-block;
  background: #c2e22a;
  border-radius: 5px;
  width: 5px;
  height: 24px;
  left: 0;
  position: absolute;
}
.contentq .title .right{
  color: #ce7735;
}
.contentq .items {
  display: flex;
  margin: 0.26667rem 0;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.contentq .items .item {
  font-weight: 500;
  display: flex;
  background: #151515;
  padding: 0.4rem;
  margin-right: 5%;
  flex: 0 0 45%;
  border-radius: 0.26667rem;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  margin-bottom: 10px;
}
.contentq .items .active {
  border: 1px solid #c0dd2b;
}
.contentq .input-lists{
  display: flex;
  justify-content: space-between;
}
.contentq .input-list{
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  flex-direction: column;
}
.contentq .input-content{
  background: #d8d8d814;
  margin: auto;
  mix-blend-mode: normal;
  border-radius: 10px;
  margin-top: 8px;
  height: 50px;
  width: 140px;
  line-height: 50px;
  padding: 0 16px 0 20px;
  display: flex;
  justify-content: space-between;
  color: #fff;
  align-items: center;
  font-weight: 600;
  font-size: 15px;
  position: relative;
}
.contentq .input-list .lable {
  font-weight: 500;
  font-size: 12px;
  color: hsla(0, 0%, 100%, .3);
}
.contentq .input-list .input-content{
  padding: 0 6px 0 24px;
  width: 100%;
  box-sizing: border-box;
}
.contentq .input-list .input-content .input-button{
  width: 54px;
  height: 34px;
  background: #1a1a1a;
  border-radius: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 34px;
  text-align: center;
}
.contentq .input-list .input-content input {
  width: calc(100% - 24px);
}
.contentq .amtInfo{
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}
.contentq .amtInfo .amtItem{
  display: flex;
  flex: 0 0 30%;
  flex-direction: column;
}
.contentq .amtInfo .amtItem .top{
  font-weight: 500;
  font-size: 12px;
  color: hsla(0, 0%, 100%, .3);
}
.contentq .amtInfo .amtItem .bottom{
  font-weight: 500;
  font-size: 15px;
  margin-top: 5px;
}
.contentq .confirm-button{
  font-weight: 600;
  font-size: 16px;
  color: #000;
  width: 100%;
  height: 48px;
  background: #c0dd2b;
  border-radius: 13px;
  text-align: center;
  line-height: 48px;
  margin-top: 10px;
}
.contentq .content1-infos{
  display: flex;
  justify-content: space-around;
  margin: auto;
}
.contentq .content1-infos .infos1{
  position: relative;
  width: 33%;
}
.contentq .content1-infos .infos1:before {
  content: "";
  display: inline-block;
  width: 2px;
  height: 74px;
  background: hsla(0, 0%, 100%, .13);
  position: absolute;
  right: 0;
  top: 12px;
}
.contentq .content1-infos .infos1 .info1 {
  height: 54px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}
.contentq .content1-infos .infos1 .info1 .info1-lable {
  font-weight: 500;
  font-size: 12px;
  color: #ffffff4d;
  margin-bottom: 6px;
}

.contentq .content1-infos .infos2{
  position: relative;
  width: 33%;
}
.contentq .content1-infos .infos2 .info1 {
  height: 54px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}
.contentq .content1-infos .infos2 .info1 .info1-lable {
  font-weight: 500;
  font-size: 12px;
  color: #ffffff4d;
  margin-bottom: 6px;
}


.pross-title {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  height: 15px;
  color: hsla(0, 0%, 100%, .3);
  text-align: left;
  margin-top: 24px;
}
.leverage-progress {
  position: relative;
  width: 100%;
  height: 2px;
  background-color: #e0e0e0;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
}
.progress {
  position: absolute;
  height: 100%;
  background-color: #4caf50;
  border-radius: 5px;
}
.progress-circular {
  position: absolute;
  top: -4px;
  width: 10px;
  height: 10px;
  background-color: #fff;
  border: 2px solid #4caf50;
  border-radius: 50%;
  transition: background-color 0.3s ease;
}
/* 当进度超过端点时应用的样式 */
.progress-active {
  background-color: #4caf50;
  border-color: #4caf50;
}
.progress-ring-active {
  width: 10px;
  height: 10px;
  background-color: #4caf50;
  border-radius: 50%;
  top: -4px;
  position: absolute;
  transition: background-color 0.3s ease;
}
.progress-identification{
  width: 100%;
  height: 16px;
  margin-top: 14px;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: hsla(0, 0%, 100%, .3);
  position: relative;
}
.identification-1x {
  position: absolute;
  left: 0;
}
.identification-25x{
  position: absolute;
  left: calc(25% - 13px);
}
.identification-50x{
  position: absolute;
  left: calc(50% - 13px);
}
.identification-75x{
  position: absolute;
  left: calc(75% - 13px);
}
.identification-100x{
  position: absolute;
  right: -8px;
}
.entrust {
  height: 24px;
  display: flex;
  justify-content: space-between;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #fff;
  margin-top: 10px;
}
.option{
  font-weight: 400;
  color: #c0dd2b;
  font-size: 14px;
  text-align: center;
  margin-right: 12px;
}
.margins {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: hsla(0, 0%, 100%, .3);
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}



input {
  outline: none;
  border: none;
}
.readonly-input {
  cursor: text;
}
button, input, textarea {
  color: inherit;
  font: inherit;
}


  .wrap {
    background: #19191b;
  }
  .wrap .header {
    background: none !important;
  }
  .wrap .teamInfo {
    background: #212122;
    background-size: 100% 100%;
    padding: 12px;
  }
  .wrap .teamInfo .top {
    font-size: 20px;
    font-weight: bold;
    color: #eb4d5c;
  }
  .wrap .teamInfo .bottom {
    margin-top: 5px;
    display: flex;
    align-items: center;
  }
  .wrap .teamInfo .bottom p {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .wrap .teamInfo .bottom p  span:first-child {
    font-size: 12px;
    color: rgba(255, 255, 255, .5);
  }
  .wrap .teamInfo .bottom p  span:last-child {
    color: #53b987;
  }
  .wrap .navbox {
    padding: 5px;
    display: flex;
    align-items: center;
    background: #212122;
    margin-top: 8px;
  }
  .wrap .navbox  .left {
    width: 100px;
    height: 34px;
    display: flex;
    align-content: center;
    background: #17171a;
    border-radius: 8px;
    padding: 3px;
  }
  .wrap .navbox  .left p {
    color: #fff;
    flex: 1;
    text-align: center;
    line-height: 28px;
  }
  .wrap .navbox  .left p .active {
    background: #323237;
    border-radius: 10px;
    color: #4494ef;
  }
  .wrap .navbox  .right {
    flex: 1;
    display: flex;
    margin-left: 5px;
    align-items: center;
  }
  .wrap .navbox  .right  p {
    flex: 1;
    padding: 5px 0;
    text-align: center;
    color: rgba(255, 255, 255, .5);
  }
  .wrap .navbox  .right  p.active {
    color: #4494ef;
    border-bottom: 1px solid #4494ef;
  }
  .wrap .main {
    background: none !important;
    display: flex;
    flex-direction: column;
  }
  .wrap .main .timebox {
    padding: 2px 12px;
    font-size: 12px;

  }
  .wrap .main .timebox span {
    margin-right: 12px;
  }
  .wrap .main .timebox span:first-child {
    color: white;
  }
  .wrap .main .timebox span:nth-child(2) {
    color: red;
  }
  .wrap .main .timebox span:nth-child(3) {
    color: blue;
  }
  .wrap .main .timebox span:nth-child(4) {
    color: green;
  }
  .wrap .main .timebox span:last-child {
    color: yellow;
  }
  .wrap .main .diffbox {
    padding: 5px 12px;

  }
  .wrap .main .diffbox span {
    margin-right: 12px;
  }
  .wrap .main .diffbox span:first-child {
    color: white;
  }
  .wrap .main .diffbox span:nth-child(2) {
    color: red;
  }
  .wrap .main .diffbox span:last-child {
    color: blue;
  }
  .wrap .main #echart01,
  .wrap .main #echart02 {
    flex: 2;
  }
  #echart03 {
    flex: 1;
  }
  .wrap .bottombox {
    display: flex;
    padding: 6px 12px;
    background: #212122;
    justify-content: space-around;
    align-items: center;
  }
  .wrap .bottombox .left {
    flex: 0 0 45%;
    background: #c2e22a;
    color: #000;
    padding: 15px 10px;
    border-radius: 5px;
    text-align: center;
    font-weight: 500;
  }
  .wrap .bottombox .left i {
    font-size: 20px;
  }
  .wrap .bottombox .left span {
    font-size: 12px;
  }
  .wrap .bottombox .right {
    flex: 0 0 45%;
    background: #ce7735;
    color: #000;
    padding: 15px 10px;
    border-radius: 5px;
    text-align: center;
    font-weight: 500;
  }
  .wrap .bottombox .right .btn {
    color: #fff;
    padding: 0 32px;
    line-height: 32px;
    font-size: 16px;
  }
  .wrap .bottombox .right .btn01 {
    border-radius: 16px;
    background: #4caa3b;
  }
  .wrap .bottombox .right .btn01::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    display: inline-block;
    border-width: 16px 4px;
    border-style: solid;
    border-color: #4caa3b #212122 #212122 #4caa3b;
  }
  .wrap .bottombox .right .btn02 {
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    margin-left: 8px;
    background: #ea3e3b;
  }
  .wrap .bottombox .right .btn02::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    border-width: 16px 4px;
    border-style: solid;
    border-color: #212122 #ea3e3b #ea3e3b #212122;
  }
  .wrap .orderbox {
    width: 100%;
    background: #212122;
    color: #fff;
  }
  .wrap .orderbox .tit {
    padding: 10px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, .5);
  }
  .wrap .orderbox .tit h2 {
    font-size: 18px;
  }
  .wrap .orderbox .itemtitle {
    display: flex;
    padding: 10px 12px;
    color: rgba(255, 255, 255, .5);
  }
  .wrap .orderbox .itemtitle  span {
    margin-right: 30px;
  }
  .wrap .orderbox .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5px;
  }
  .wrap .orderbox .item p {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .wrap .orderbox .item .item01 p {
    margin: 5px;
    padding: 10px;
    border-radius: 6px;
    background: #3d3d3d;
  }
  .wrap .orderbox .item .item01 p  span:first-child {
    color: #4494ef;
  }
  .wrap .orderbox .item .item01 p  span:last-child {
    color: #fff;
  }
  .wrap .orderbox .item .item01 p.active {
    border: 1px solid #4494ef;
  }
  .wrap .orderbox .item .item02  p {
    margin: 5px;
    padding: 10px;
    border-radius: 6px;
    background: #3d3d3d;
  }
  .wrap .orderbox .item .item02  p.active {
    color: #4494ef;
    border: 1px solid #4494ef;
  }
  .wrap .orderbox .item .item02  input {
    width: 100%;
    text-align: center;
    color: #fff;
  }
  .wrap .orderbox .item .item03 p span:first-child {
    color: rgba(255, 255, 255, .5);
    margin-bottom: 3px;
  }
  .wrap .orderbox .item .item03  .blue {
    color: #4494ef;
  }
  .wrap .orderbox .item .item03 .red {
    color: #ea3e3b;
  }
  .wrap .orderbox .item .item03 .green {
    color: green;
  }
  .wrap .orderbox .btn {
    margin: 12px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: #4494ef;
    font-size: 16px;
  }
  .wrap .orderbox .bottom {
    color: #4494ef;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .wrap .orderbox .bottom  span:last-child {
    margin-left: 20px;
  }
  .wrap .orderInfo{
    width: 100%;
    height: 100%;
    background: #19191b;
  }
  .wrap .orderInfo .header{
    padding: 10px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color:#fff;
  }
  .wrap .orderInfo .header h2 {
    font-size: 18px;
  }
  .wrap .orderInfo .timebox{
    width:150px;
    height: 150px;
    border-radius: 50%;
    margin:30px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 24px;
    color:#fff;
    border:3px solid rgba(255, 255, 255, .3);
  }
  .wrap .orderInfo .timebox span:first-child{
    font-size: 20px;
  }
  .wrap .orderInfo .timebox span:last-child{
    color:#ea3e3b;
    font-size: 16px;
  }
  .wrap .orderInfo .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5px;
  }
  .wrap .orderInfo .content  p {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    color:#fff;
  }
  .wrap .orderInfo .content  p  span:first-child {
    color: rgba(255, 255, 255, .5);
    margin-bottom: 3px;
  }
  .wrap .orderInfo .content  .blue {
    color: #4494ef;
  }
  .wrap .orderInfo .content .red {
    color: #ea3e3b;
  }
  .wrap .orderInfo .content  .green {
    color: green;
  }
  .wrap .orderInfo .btn {
    width:80%;
    margin: 20px auto;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #5495e6;
    background: #121214;
    border-radius: 14px;
    font-size: 16px;
    color:#fff;
  }
</style>